<div class="elementor-element elementor-element-51dc4360 elementor-button-align-stretch elementor-widget elementor-widget-form" data-id="51dc4360" data-element_type="widget" data-settings="{&quot;step_next_label&quot;:&quot;Next&quot;,&quot;step_previous_label&quot;:&quot;Previous&quot;,&quot;button_width&quot;:&quot;100&quot;,&quot;step_type&quot;:&quot;number_text&quot;,&quot;step_icon_shape&quot;:&quot;circle&quot;}" data-widget_type="form.default">
    <h4>
        Please complete the details below. You will receive an OTP via SMS for number verification. Verification is necessary to proceed
    </h4>
    <div class="elementor-widget-container">
        <form class="elementor-form customer-sign-up-form" @submit.prevent="validateForm">
            <div class="elementor-form-fields-wrapper elementor-labels-">
                <div class="elementor-field-type-text elementor-field-group elementor-column elementor-field-group-FullName elementor-col-100 elementor-field-required">
                    <label for="form-field-FullName" class="elementor-field-label elementor-screen-only">
                        First Name
                    </label>
                    <div v-if="firstName.hasError" class="text-danger">
                        {{firstName.errorMessage}}
                    </div>
                    <input type="text" id="form-field-FullName" class="elementor-field elementor-size-sm  elementor-field-textual" placeholder="First Name" required="required" aria-required="true" v-model="firstName.value">
                </div>
                <div class="elementor-field-type-text elementor-field-group elementor-column elementor-field-group-FullName elementor-col-100 elementor-field-required">
                    <label for="form-field-lastName" class="elementor-field-label elementor-screen-only">
                        Last Name
                    </label>
                    <div v-if="lastName.hasError" class="text-danger">
                        {{lastName.errorMessage}}
                    </div>
                    <input type="text" id="form-field-lastName" class="elementor-field elementor-size-sm  elementor-field-textual" placeholder="Last Name" required="required" aria-required="true" v-model="lastName.value">
                </div>
                <div class="elementor-field-type-text elementor-field-group elementor-column elementor-field-group-email elementor-col-100 elementor-field-required">

                    <div v-if="mobileNumber.hasError" class="text-danger">
                        {{mobileNumber.errorMessage}}
                    </div>
                    <label for="form-field-mobileNumber" class="input-group">
                        <div class="input-group-icon">+</div>
                        <div class="input-group-area">
                            <input type="tel" id="form-field-mobileNumber" class="elementor-field elementor-size-sm  elementor-field-textual" placeholder="Mobile Number" required="required" aria-required="true" v-model="mobileNumber.value"
                                   @input="onMobileNumberInput">
                        </div>
                    </label>
                    
                    
                </div>
                <div class="elementor-field-group elementor-column elementor-field-type-submit elementor-col-100 e-form__buttons">
                    <button type="submit" class="elementor-button elementor-size-sm" :disabled="loading">
                        <span>
                            <span class=" elementor-button-icon">
                            </span>
                            <span class="elementor-button-text">Continue</span>
                        </span>
                    </button>
                </div>
            </div>
        </form>
    </div>
</div>
